import { useEffect } from 'react'

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString)
  const now = new Date()

  const isToday =
    date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear()

  const optionsToday: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false // Optional: Use 24-hour format
  }

  if (isToday) {
    return date.toLocaleTimeString([], optionsToday)
  } else {
    const optionsOthers: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Optional: Use 24-hour format
    }
    return date.toLocaleDateString(undefined, optionsOthers)
  }
}

export const useHideScrollBar = (isModalOpen: boolean) => {
  useEffect(() => {
    const lockScroll = () => {
      document.body.style.overflow = 'hidden'
    }

    const unlockScroll = () => {
      document.body.style.overflow = 'auto'
    }

    if (isModalOpen) {
      lockScroll()
    } else {
      unlockScroll()
    }

    return () => {
      unlockScroll()
    }
  }, [isModalOpen])
}
